import TextNavBackground from "../components/common/TextNavBackground";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kPrivacyPolicyURL } from "../utils/constants/apiUrls";
import { SIX_MONTHS_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import MarkdownRender from "../components/common/MarkdownRender";
import { customStaticSeoConfig, getApiToken } from "../utils/helpers/helpers";
import { PRIVACY_POLICY_URL } from "../utils/constants/websiteUrls";
import { TabNoData } from "../components/common/NoData";

const PrivacyPolicy = ({ privacyPolicy }) => {
  // SAFE FIX: Provide an empty object default to prevent destructuring crashes
  const { privacy_policy: privacyPolicyInfo = "" } = privacyPolicy || {};

  const url = PRIVACY_POLICY_URL;

  return (
    <>
      {customStaticSeoConfig("Privacy policy")}
      <TextNavBackground title="Privacy policy" />

      {privacyPolicyInfo === "" && <TabNoData />}

      {privacyPolicyInfo !== "" && (
        <MarkdownRender
          title={"Asante Kotoko SC Privacy Policy"}
          caption={
            "Privacy Policy for using the Asante Kotoko website and app."
          }
          url={url}
          markdownData={privacyPolicyInfo}
        />
      )}
    </>
  );
};

export default PrivacyPolicy;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const privacyPolicy = await apiWrapper.get(kPrivacyPolicyURL, token);

  return {
    props: {
      // SAFE FIX: Use an empty object fallback down to preserve rendering properties safely
      privacyPolicy: privacyPolicy?.data || {},
    },
    revalidate: SIX_MONTHS_REFRESH_INTERVAL_SECONDS,
  };
};
